import { t } from "i18next";

import Star from "@/assets/icons/big-star.svg?react";
import { LevelProps } from "@/interfaces/components";

import styles from "./styles";

export const Level = ({ title, description, style, level, img, additionalActions }: LevelProps) => {
  return (
    <styles.Level>
      <styles.Header>
        <styles.StarContainer $starColor={style.border}>
          <Star />
        </styles.StarContainer>
        <img src={img} />
        <styles.LevelOctagon $colors={style}>{t("Levels.Level", { level: level })}</styles.LevelOctagon>
      </styles.Header>
      <styles.Footer>
        <styles.LevelTextCol>
          <styles.LevelTitle>{title}</styles.LevelTitle>
          {description && <styles.LevelDescription>{description}</styles.LevelDescription>}
        </styles.LevelTextCol>
        {additionalActions || null}
      </styles.Footer>
    </styles.Level>
  );
};
